import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import M from 'materialize-css';
import HorizontalCard from './components/HorizontalCard';

function EventYouTube({ videoId, title, thumb }) {
  const iframeRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const play = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&playsinline=1`;
    }
    setPlaying(true);
  };

  return (
    <div className="video-thumbnail-container">
      <iframe
        ref={iframeRef}
        className={`video-embed${playing ? ' is-playing' : ''}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        tabIndex={playing ? 0 : -1}
      />
      {!playing && (
        <button type="button" className="video-play-hit" onClick={play} aria-label={`Play ${title}`}>
          <img src={thumb} alt={title} className="video-thumbnail" />
          <span className="play-button">
            <i className="material-icons">play_circle_filled</i>
          </span>
        </button>
      )}
    </div>
  );
}

function App() {
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [projectsIndex, setProjectsIndex] = useState(0);
  const [blogsIndex, setBlogsIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [teamOpen, setTeamOpen] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const toggleTeam = (id) => setTeamOpen(prev => ({ ...prev, [id]: !prev[id] }));
  const radhikaBio = `Radhika Shah is Cofounder & Co-President of the recently launched Stanford Alumni Alliance of Innovation for Global Impact (co-anchored within the Stanford King Center for Global Development with an initial focus on AI for the SDGs) and former Co-President of Stanford Angels & Entrepreneurs. She is a tech-impact investor and deep believer in digital innovation & policy's role in accelerating the SDGs. She is also Cofounder and Co-Chair of the SDG Digital Transformation & Sustainability Solutions Lab which is bringing together brilliant minds to leverage tech and data science innovation to advance the SDGs.

Radhika is a staunch believer in role of policy and community to accelerate social change, is on the board of the Center for Effective Global Action (CEGA), U.C. Berkeley and Impact Experience and is Founding Co-Chair of the United Nations Joint SDG Fund Breakthrough Alliance which leverages tech, media and markets to advance sustainable futures and create opportunities for all.

Influenced by Gandhian philosophy, Radhika cares deeply about sustainability, human dignity, and women's socio-economic empowerment. She is and has been an advisor to Illumen Capital, the former SDG Philanthropy Platform, ATREE USA which helps communities protect and restore ecosystems they live in, and Benetech & MakerGhat in the education transformation space.

Radhika has been a member of the Center for Global Development study group on AI, Technology Comparative Advantage & Development Prospects and participated in co-designing a Stanford study, co-authored peer-reviewed-papers, and had articles published in Proceedings of the National Academy of Sciences, the UN, Thomson Reuters, and other national/regional media. She holds a Masters in Computer Science from Stanford University and an MBA from U.C. Berkeley.`;
  const divaBio = `Diva Avaya Sharma is a technology entrepreneur and founder of Cognitio Labs, an institutionally backed company building infrastructure across regulatory contracting for public health systems. She serves as a Board Member at Stanford Entrepreneurs and is Co-Founder and Co-President of the Stanford Alumni Alliance on Innovation for Global Impact, in partnership with the Stanford King Center on Global Development. She is also a member of the World Economic Forum's Future 26 Cohort, a highly selective group of emerging global leaders shaping the future of technology, policy, and society. Through this cohort, she works with cross-sector leaders to drive dialogue and action on critical global challenges in support of the World Economic Forum's mission to improve the state of the world.

Diva brings experience across venture capital as one of the few North American fellows at Bessemer Venture Partners, 8VC, and Pear Ventures, where she worked closely with portfolio companies. Her work spans Fortune 500 organizations including Johnson and Johnson MedTech and Meta, as well as governments and economic innovation labs such as the Golub Capital Social Impact Lab and the Stanford Venture Capital Initiative at the Stanford Graduate School of Business, operating at the intersection of technology, policy, and growth.

She is the inventor of a patented rural health monitoring device recognized by the Government of India, the World Bank, and the European Commission. Her work has been recognized by Forbes 30 Under 30, Economic Times, Times of India, and the President of India. Her TEDx talk was selected as one of eight globally for the Bill and Melinda Gates Foundation Girl Empowerment playlist, reaching more than 80,000 people. She graduated from Stanford University with a BS in Computer Science. She lives in San Francisco and is an active leader in the Global Shapers San Francisco Hub and the Lean In Network San Francisco, a nonprofit focused on advancing women's empowerment.`;

  const thayBio = `Thay Graciano is a Knight-Hennessy Scholar and PhD researcher at Stanford, where she works in AI governance and economic development through technological infrastructure. Originally from Brazil, she brings a practitioner's perspective to questions of institutional design and development. Her research examines how AI policy and infrastructure investment interact with institutional quality across emerging economies. She is a member of the founding team of the Stanford Alliance on AI for the SDGs, and Vice-President of Global Innovation Policy.`;

  const roshniBio = `Roshni Sahoo is an Assistant Professor in the Decision, Risk, and Operations group at Columbia Business School. Her research focuses on data-driven decision making, combining tools from machine learning, causal inference, and optimization. She is particularly interested in developing statistical methodology to address challenges in public health and economic development. She completed her PhD in Computer Science at Stanford University and her BS degree in Computer Science and Mathematics at MIT.`;

  const suhaniBio = `Dr. Suhani Jalota is an applied microeconomist and an entrepreneur focused on labor markets, health access, and AI adoption in emerging economies. She is a Hoover Fellow at the Hoover Institution at Stanford University, where her field experiments examine barriers to workforce participation and health system access, and test AI-enabled interventions to raise productivity at scale.

Jalota founded the Myna Mahila Foundation, a research-driven social enterprise (founded 2015) dedicated to expanding women's agency, health, and livelihoods, which now reaches 1.5 million women with a team of 70 in India; Myna Research, which runs field experiments in urban slums; and Rani Work, a platform enabling smartphone-based digital employment.

She founded and leads Stanford's Future of Work for Women Initiative, a cross-sector initiative with the Hoover Institution to build evidence and partnerships to accelerate workforce entry and firm productivity, with a long-run goal of moving tens of millions into paid work and the digital economy by 2040.

She is a World Economic Forum Young Global Leader, Forbes Asia Under 30 recipient, Top 33 She Shapes AI Awardee, Asia 21 Leader, Young Achiever's Mother Teresa Memorial Awardee, Queen's Young Leader, and named to the top 50 under 50 most powerful women by India Today. As a Duke graduate and with a PhD/MBA from Stanford University as a Knight Hennessy Scholar, she brings together economics, technology, and grassroots implementation to drive large-scale impact.`;

  const sarahiBio = `Sarahi Espinoza Salamanca is a Mexican-born technologist, social entrepreneur, and policy advocate committed to expanding access to higher education and economic opportunity for first-generation communities. She currently serves as Project Manager for the Education Entrepreneurship Hub at the Stanford Accelerator for Learning, where she leads cross-functional initiatives at the intersection of education, innovation, and equity. In this role, she manages complex projects spanning planning, execution, and evaluation, partnering with educators, researchers, and entrepreneurs to advance inclusive solutions in the education ecosystem. Her work emphasizes collaborative design, stakeholder engagement, and the scaling of impactful, equity-driven innovations.

She is also the founder and CEO of DREAMers Roadmap, an award-winning mobile app that connects undocumented students with scholarships, internships, and career pathways they can legally pursue. Drawing on her lived experience as a former undocumented student who once left community college to support her family, Sarahi has dedicated her career to dismantling systemic barriers in education. Her work spans technology, innovation, philanthropy, and policy with a focus on advancing equity for historically marginalized communities.

Sarahi's leadership has earned national recognition, including being named a White House Champion of Change, a Forbes 30 Under 30 honoree, and a member of Forbes Mexico's 100 Most Powerful Women. In 2020, she led large-scale mutual aid efforts through the #FirstOfTheMonth and #Supplies4FarmWorkers campaigns, raising $2.7 million to support vulnerable communities impacted by COVID-19 and California wildfires in Sonoma, CA, and beyond. In 2022, she joined The Sobrato Family Foundation as a Senior Program and Strategy Advisor, where she led community engagement and helped shape regional strategies centered on Community Voice and Lived Experience.

Sarahi earned a Bachelor of Science in Sociology and a Bachelor of Arts in Ethnic Studies from Santa Clara University, graduating Cum Laude + Alpha Sigma Nu in June 2024. In June 2025, she earned her Master's degree as a Knight-Hennessy Scholar in Policy, Organization, and Leadership Studies at Stanford University School of Education.`;

  const bhavBio = `Bhav Jain is pursuing an MD at Stanford School of Medicine. He graduated from the Massachusetts Institute of Technology with a bachelor's degree in computer science and brain and cognitive sciences. Bhav aspires to create high-value, low-cost health care systems and to transform clinical care globally as a physician-policymaker.

His research spans health disparities and health system transformation, and is published in outlets such as JAMA, JAMA Oncology, JAMA Pediatrics, and Nature Medicine. A former fellow at the Boston Public Health Commission, Bhav now leads the Social Equity Action Lab to advise politicians and electoral candidates on healthcare reform. He is a recipient of the Knight-Hennessy, Samvid, and Truman Scholarships.`;

  const jennaBio = `Jenna Nicholas is an investor, entrepreneur, advisor, best selling author, coach and speaker. She is the President of LightPost Capital, an investment and acquisition firm, and the Co-Founder and CEO of Impact Experience, which advances equity across climate, healthcare, education, and investments. Jenna is the best selling author of Enlightened Bottom Line: Exploring the intersection of spirituality, business and investing.

An active angel investor, Jenna has backed over three unicorns. She previously served as Investment Partner at One Planet Group, where she also led corporate development and acquired four companies. Prior, she worked with the World Bank Treasury on green bonds and sustainability projects, with Toniic supporting its global impact community, and with the Calvert Special Equities team investing in education technology, financial inclusion, renewable energy, and sustainable agriculture.

As Project Manager of Divest-Invest Philanthropy, she led a coalition of foundations shifting capital from fossil fuels into impact solutions, which she shared on the TEDx Portland stage. Jenna serves as an advisor to Ethic and the Nexus Global Youth Summit and previously sat on Apollo Global Management's Impact Advisory Committee. She co-chaired the Emerging Leaders Council of LISC, co-taught at Tsinghua School of Economics and Management, and is Vice President of Stanford Angels and Entrepreneurs.

She holds an MBA from Stanford Graduate School of Business, a BA in International Relations from Stanford with study at Oxford University, and has been recognized as a Forbes 30 Under 30 Social Entrepreneur, PDSoros Fellow, Echoing Green Fellow, and is a Council on Foreign Relations member. Jenna serves on the board and investment committee of the Oakland Museum of California. Her work has been featured in the New York Times, Financial Times, and Forbes. Jenna is an active member of the Bahá'í Faith.`;

  const sasankhBio = `Sasankh Munukutla is a climate-tech entrepreneur and AI researcher by training. He is deeply passionate about applying frontier technology to humanity's most pressing problems, having worked across climate, accessibility, and refugees.

He is currently the Co-Founder of Terradot, a climate-tech startup working on gigaton-scale carbon removal backed by $58M+ in venture funding, including from John Doerr/Kleiner Perkins, Google, and Microsoft. Sasankh has published AI research at top conferences like NeurIPS and ICLR and also served on the Singapore delegation at the UN COPs to advance global climate policy.

Before founding Terradot, Sasankh graduated from Stanford with a BS and MS in Computer Science (AI track). During his time at Stanford, Sasankh worked on AI for Climate research under Prof. Andrew Ng, led and expanded CS+Social Good, and served on the Haas Center's National Advisory Board. Originally from Singapore, he grew up across Asia, which instilled in him a deep commitment to global development. He served as a commander in the Singapore Armed Forces for 2 years before college.`;

  const adityaBio = `Aditya Vishwanath is an education technology researcher and entrepreneur working at the intersection of emerging technologies, learning, and social impact. His work focuses on building AI-powered tools that make learning more engaging, accessible, and meaningful — especially in public schools, vocational programs, and underserved communities.

He is currently Vice President at Macmillan Learning's Innovation Labs group, where he leads work on AI, XR, and emerging technology in K-12 and higher education.

Previously, he was the co-founder and CEO of Inspirit (acquired by Avantis Education in early 2026), a venture-backed startup building immersive, AI-enabled VR tools to train students in K-12 and vocational settings. Inspirit raised over $9 million from leading investors including the founders of Yahoo and Oculus, with strategic partnerships with Meta, Snap, and the NFL. At its peak in late 2025, Inspirit sustained one of the largest XR programs in U.S. K-12 education.

He is also the co-founder of MakerGhat, one of India's (and the world's) largest makerspace networks. Launched in Mumbai in December 2018, MakerGhat now reaches over 2 million youth across 10,000+ schools in six Indian states — activating hands-on learning and grassroots innovation at scale.

Aditya earned his Ph.D. in Learning Sciences from Stanford University as a Knight-Hennessy Scholar, and his B.S. in Computer Science from Georgia Tech. He is currently a Visiting Research Scholar at Stanford's Graduate School of Education, where he studies the nuanced impacts of AI and XR on learning and youth agency.

His work has been featured in Nature, Freakonomics, and The Indian Express, and recognized by Forbes 30 Under 30, Ashoka Fellowship, Schmidt Futures, MIT SOLVE, SXSW EDU, Georgia Tech 40 Under 40, and the Exploratorium Osher Program.

Beyond his primary roles, he serves on the boards of MakerGhat and Mantra4Change USA, and advises organizations at the frontier of AI and education — including The Convergence Foundation, Shikha Labs, and the Exploratorium's Glassroom Initiative. He also gives back to the research community as a reviewer for NSF panels and ACM venues including CHI, DIS, and CSCW, and as a mentor at Stanford GSE's Education Entrepreneurship Hub.

At the heart of it all, he is driven to reimagine learning ecosystems — where young people everywhere can experiment, build, and learn with the tools of the future.`;

  const coPresidents = [
    { id: 'copres1', name: 'Radhika Shah', title: 'Co-Founder & Co-President', description: radhikaBio, linkedin: 'https://www.linkedin.com/in/radhikashah1/', image: '/img/radhika.jpg' },
    { id: 'copres2', name: 'Diva Avaya Sharma', title: 'Co-Founder & Co-President', description: divaBio, linkedin: 'https://www.linkedin.com/in/diva-sharma/', image: '/img/U-8989.jpg' },
  ];

  const foundingTeam = [
    { id: 'ft1', name: 'Thay Graciano', title: 'Vice-President of Global Innovation Policy, Founding Team Member', description: thayBio, linkedin: 'https://knight-hennessy.stanford.edu/people/thay-graciano', image: '/img/thay-graciano.jpeg' },
    { id: 'ft2', name: 'Roshni Sahoo', title: 'Founding Team Member', description: roshniBio, linkedin: '#', image: '/img/roshni_sahoo.jpeg' },
    { id: 'ft3', name: 'Suhani Jalota', title: 'Founding Team Member', description: suhaniBio, linkedin: '#', image: '/img/suhani-jalota.jpeg' },
    { id: 'ft4', name: 'Sarahi Espinoza Salamanca', title: 'Founding Team Member', description: sarahiBio, linkedin: 'https://knight-hennessy.stanford.edu/people/sarahi-espinoza-salamanca', image: '/img/sarahi-salamanca.jpg' },
    { id: 'ft5', name: 'Sasankh Munukutla', title: 'Founding Team Member', description: sasankhBio, linkedin: '#', image: '/img/sasankh-munukutla.jpeg' },
    { id: 'ft6', name: 'Jenna Anita Nicholas', title: 'Founding Team Member', description: jennaBio, linkedin: '#', image: '/img/jenna-nicholas.jpg' },
    { id: 'ft7', name: 'Bhav Jain', title: 'Founding Team Member', description: bhavBio, linkedin: '#', image: '/img/bhav-jain.jpeg' },
    { id: 'ft8', name: 'Aditya Vishwanath', title: 'Founding Team Member', description: adityaBio, linkedin: 'https://thegistof.me/adi', image: '/img/aditya-vishwanath.jpg' },
  ];

  const projects = [
    {
      icon: 'tablet_mac',
      title: 'Post-Opoid Behavior Tracking App',
      description: 'Through the Stanford School of Medicine and CS342 Course at Stanford, I was part of a team that developed a post-opioid tracking mobile app that analyzed physiological and activity data. I primarily worked with HealthKit and ResearchKit from the Apple Developers Toolkit.'
    },
    {
      icon: 'local_hospital',
      title: 'Clinical Gaps Due to Legacy EHRs',
      description: 'Independent research through the Stanford Human Computer Interaction Department wherein I identified major gaps in clinical workflow due to legacy electronic-health records software. Interviewed major stakeholders at Stanford, VA & Community Hospitals.'
    },
    {
      icon: 'show_chart',
      title: 'Financial Analytics KPI Dashboard',
      description: 'Engineered a financial analytics dashboard that represented first and second-order financial metrics in real-time. Dealt with disparate data sources ranging from legacy software like Bloomberg Terminals to enterprise softwares like HubSpot&Periscope. Powered KPIs in real-time.'
    },
    {
      icon: 'local_pharmacy',
      title: 'Clinical Trial Analytics',
      description: 'Understanding and lanscaping the role of international CRO(s) in the facilitation for clinical trials during Phase II and Phase III drug studies. I delved deeper into the economies of scale achieved, the data aggregated by CROs, and areas of improvement to shorten trial timelines and improve R&D efficiency by 10x. Unravelled engagement rates for trials in developing countries.'
    },
    {
      icon: 'device_hub',
      title: 'Petsafe',
      description: 'Developed a device that can quantify physiological distress with 90% accuracy. Analyzed heart-rate, pulse oximetry, perspiration, and respiratory rate for dogs to quantify physiological distress and alert authorities during medical emergency. The long-term goal is to serve as a remote-patient monitoring tool for humans during chronic disease.'
    },
    {
      icon: 'photo_album',
      title: 'Integrated Photo-App',
      description: "For Stanford's web-applications class (CS142), I developed a React-js based photo-app that enabled users to view profiles, add friends, customize their own profiles, add and update photos, and delete their accounts. I enhanced my skill-set with web development skills that enabled me to build a social networking website equipped with noSQL databases and server-side + browser-side support."
    }
  ];

  const nextProjects = () => {
    setProjectsIndex((prev) => {
      const maxIndex = Math.max(0, projects.length - 3);
      return prev + 3 > maxIndex ? 0 : prev + 3;
    });
  };

  const prevProjects = () => {
    setProjectsIndex((prev) => {
      const maxIndex = Math.max(0, projects.length - 3);
      return prev - 3 < 0 ? maxIndex : prev - 3;
    });
  };

  const blogs = [
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' },
    { title: 'Coming Soon', description: 'Articles and blog posts will be featured here.' }
  ];


  const nextBlogs = () => {
    setBlogsIndex((prev) => {
      const maxIndex = Math.max(0, blogs.length - 3);
      return prev + 3 > maxIndex ? 0 : prev + 3;
    });
  };

  const prevBlogs = () => {
    setBlogsIndex((prev) => {
      const maxIndex = Math.max(0, blogs.length - 3);
      return prev - 3 < 0 ? maxIndex : prev - 3;
    });
  };

  // const handleContactSubmit = (e) => {
  //   e.preventDefault();
  //   setFormSubmitted(true);
  // };


  const carouselImages = [
    { image: '/img/XT4C3045-2.jpeg',                position: 'center 42%',    mobilePosition: 'center 42%',   year: '2026', caption: 'Alliance Launch at Stanford King Center' },
    { image: '/img/Stanford_second.jpeg',           position: 'center 60%',    mobilePosition: 'center 60%' },
    { image: '/img/IMG_0052_Alliance_Meeting.jpeg', position: 'center center',  mobilePosition: 'center 30%',   year: '2026', caption: 'Alliance Launch at Stanford King Center' },
  ];

  // Filter out empty items on mobile, show all items on desktop
  const filteredCarouselImages = isMobile 
    ? carouselImages.filter(item => item.image && item.image.trim() !== '')
    : carouselImages;

  const nextSlide = () => {
    setCarouselIndex((prev) => (prev + 1) % filteredCarouselImages.length);
  };

  const prevSlide = () => {
    setCarouselIndex((prev) => (prev - 1 + filteredCarouselImages.length) % filteredCarouselImages.length);
  };

  // Auto-rotate hero carousel every 4 seconds, restarts when page becomes visible
  useEffect(() => {
    const len = carouselImages.length;
    if (len === 0) return;

    let interval = setInterval(() => {
      setCarouselIndex((prev) => (prev + 1) % len);
    }, 4000);

    const handleVisibility = () => {
      if (!document.hidden) {
        clearInterval(interval);
        interval = setInterval(() => {
          setCarouselIndex((prev) => (prev + 1) % len);
        }, 4000);
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Handle window resize for mobile detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Initialize Materialize components
    const sideNav = document.querySelector('.sidenav');
    if (sideNav) {
      const instance = M.Sidenav.init(sideNav, {
        edge: 'right',
        draggable: false,
        inDuration: 200, // Faster open animation (default is 250)
        outDuration: 150, // Faster close animation (default is 200)
        onOpenStart: () => {
          // Force centering when opening, positioned slightly below hamburger
          if (window.innerWidth <= 768) {
            sideNav.style.left = '50%';
            sideNav.style.right = 'auto';
            sideNav.style.top = 'calc(50% + 35px)';
            sideNav.style.transform = 'translateX(-50%) translateY(-50%)';
          }
        },
        onOpenEnd: () => {
          // Ensure centered after animation
          if (window.innerWidth <= 768) {
            sideNav.style.transform = 'translateX(-50%) translateY(-50%)';
          }
        },
        onCloseEnd: () => {
          // Reset transform when closed for next open
          if (window.innerWidth <= 768) {
            sideNav.style.transform = '';
          }
        }
      });
      
      // Close menu when clicking on menu links (with slight delay for smooth navigation)
      const menuLinks = sideNav.querySelectorAll('.mobile-menu-link');
      menuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          // Allow default navigation but close menu quickly
          setTimeout(() => {
            if (instance.isOpen) {
              instance.close();
            }
          }, 50);
        });
      });
      
      // Store instance globally for easy access
      window.mobileNavInstance = instance;
      
      // Handle window resize
      const handleResize = () => {
        if (window.innerWidth <= 768 && instance.isOpen) {
          sideNav.style.left = '50%';
          sideNav.style.right = 'auto';
          sideNav.style.top = '50%';
          sideNav.style.transform = 'translateX(-50%) translateY(-50%)';
        }
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
    

    // Initialize scrollspy
    const scrollSpy = document.querySelectorAll('.scrollspy');
    if (scrollSpy.length > 0) {
      M.ScrollSpy.init(scrollSpy, {});
    }

    // Initialize materialbox for images
    const materialbox = document.querySelectorAll('.materialboxed');
    if (materialbox.length > 0) {
      M.Materialbox.init(materialbox, {});
    }

    // Initialize input fields
    M.updateTextFields();

    // Ensure Font Awesome is loaded
    const checkFontAwesome = setInterval(() => {
      if (window.FontAwesome || document.querySelector('.fa-linkedin')) {
        clearInterval(checkFontAwesome);
      }
    }, 100);
    
    setTimeout(() => clearInterval(checkFontAwesome), 5000);
  }, []);

  return (
    <div className="App" id="top">
      {/* Navbar */}
      <div className="navbar-fixed">
        <nav className="navbar-custom">
          <div className="nav-container">
            <div className="brand-wrapper">
              <a href="#top" className="brand-logo-link">
                <img src="/img/Global Impact group logo W.jpg" alt="Stanford Alumni Alliance Logo" className="brand-logo-image" />
              </a>
              <a href="#top" className="brand-name">
                <span className="brand-text">Stanford Alumni Alliance on Innovation for Global Impact</span>
              </a>
            </div>
            <a href="#!" data-target="mobile-nav" className="sidenav-trigger mobile-menu">
              <i className="material-icons">menu</i>
            </a>
            <div className="nav-links-container">
              <ul className="nav-links hide-on-med-and-down">
                <li><a href="#about">About</a></li>
                <li><a href="#team">Team</a></li>
                <li><a href="#sdgs">Events</a></li>
                <li><a href="#councils">AI for SDG Councils</a></li>
                {/* <li><a href="#contact">Contact</a></li> */}
              </ul>
            </div>
            <div className="nav-right-group">
              <div className="social-icons-container">
                <a href="https://www.linkedin.com/posts/stanfordkingctr_sdg-aiforgood-ai-activity-7402200795414487040-c0T1?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAABp-tjEBDokRwzKqfLf7eX_le4HBw12mAlc" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://groups.stanford.edu/topics/48991/feed" target="_blank" rel="noopener noreferrer" className="social-icon" style={{overflow: 'hidden'}}>
                  <img src="/img/stanford.jpeg" alt="Stanford" style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}} />
                </a>
              </div>
              <a href="https://groups.stanford.edu/topics/48991/feed" target="_blank" rel="noopener noreferrer" className="nav-join-btn">
                join <i className="material-icons" style={{fontSize: '1rem', verticalAlign: 'middle', marginLeft: '4px'}}>arrow_forward</i>
              </a>
            </div>
          </div>
        </nav>
      </div>

      {/* Mobile Nav */}
      <ul className="sidenav mobile-dropdown" id="mobile-nav">
        <li><a href="#about" className="mobile-menu-link">About</a></li>
        <li><a href="#team" className="mobile-menu-link">Team</a></li>
        <li><a href="#sdgs" className="mobile-menu-link">Events</a></li>
        <li><a href="#councils" className="mobile-menu-link">AI for SDG Councils</a></li>
        {/* <li><a href="#contact" className="mobile-menu-link">Contact</a></li> */}
        <li style={{marginTop: '2rem', padding: '0 1rem'}}>
          <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
            <a href="https://www.linkedin.com/posts/stanfordkingctr_sdg-aiforgood-ai-activity-7402200795414487040-c0T1?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAABp-tjEBDokRwzKqfLf7eX_le4HBw12mAlc" target="_blank" rel="noopener noreferrer" className="mobile-menu-button-outline">
              LinkedIn
            </a>
            <a href="https://groups.stanford.edu/topics/48991/feed" target="_blank" rel="noopener noreferrer" className="mobile-menu-button-filled">
              Stanford Groups
            </a>
          </div>
        </li>
      </ul>

      {/* Hero Carousel */}
      <div
        style={{width: '100%', height: isMobile ? '240px' : '460px', position: 'relative', overflow: 'hidden', lineHeight: 0}}
      >
        {/* Slides */}
        {filteredCarouselImages.map((item, idx) => (
          <div
            key={idx}
            style={{
              position: 'absolute', inset: 0,
              opacity: idx === carouselIndex ? 1 : 0,
              transition: 'opacity 0.9s ease',
              zIndex: idx === carouselIndex ? 1 : 0,
            }}
          >
            <img
              src={item.image}
              alt="Stanford Campus"
              style={{
                width: '100%', height: '100%',
                objectFit: 'cover',
                objectPosition: isMobile ? (item.mobilePosition || item.position || 'center center') : (item.position || 'center center'),
                display: 'block',
                filter: 'contrast(1.08) saturate(1.1)',
              }}
            />
            {/* Caption overlay */}
            {(item.year || item.caption) && (
              <div style={{
                position: 'absolute', inset: 0,
                background: 'linear-gradient(to top, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.18) 55%, transparent 100%)',
                display: 'flex', flexDirection: 'column',
                justifyContent: 'flex-end',
                padding: '2rem 2.5rem',
              }}>
                {item.year && (
                  <span style={{
                    display: 'block',
                    fontSize: isMobile ? '0.58rem' : '0.7rem', fontWeight: '700',
                    letterSpacing: '0.18em', textTransform: 'uppercase',
                    color: 'rgba(255,255,255,0.7)',
                    marginBottom: '0.25rem',
                  }}>
                    {item.year}
                  </span>
                )}
                {item.caption && (
                  <span style={{
                    display: 'block',
                    fontSize: isMobile ? '0.95rem' : '1.45rem', fontWeight: '700',
                    color: '#fff',
                    lineHeight: '1.2',
                    letterSpacing: '-0.01em',
                    textShadow: '0 1px 6px rgba(0,0,0,0.4)',
                    maxWidth: isMobile ? '280px' : '520px',
                  }}>
                    {item.caption}
                  </span>
                )}
              </div>
            )}
          </div>
        ))}

        {/* Prev / Next arrows */}
        <button
          onClick={prevSlide}
          aria-label="Previous image"
          style={{
            position: 'absolute', left: isMobile ? '0.4rem' : '1rem', top: '50%',
            transform: 'translateY(-50%)', zIndex: 10,
            background: 'rgba(0,0,0,0.35)', border: 'none',
            borderRadius: '50%', width: isMobile ? '30px' : '40px', height: isMobile ? '30px' : '40px',
            color: '#fff', cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
          }}
        >
          <i className="material-icons" style={{fontSize: isMobile ? '1.1rem' : '1.5rem'}}>chevron_left</i>
        </button>
        <button
          onClick={nextSlide}
          aria-label="Next image"
          style={{
            position: 'absolute', right: isMobile ? '0.4rem' : '1rem', top: '50%',
            transform: 'translateY(-50%)', zIndex: 10,
            background: 'rgba(0,0,0,0.35)', border: 'none',
            borderRadius: '50%', width: isMobile ? '30px' : '40px', height: isMobile ? '30px' : '40px',
            color: '#fff', cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
          }}
        >
          <i className="material-icons" style={{fontSize: isMobile ? '1.1rem' : '1.5rem'}}>chevron_right</i>
        </button>

        {/* Dot indicators */}
        <div style={{
          position: 'absolute', bottom: '1rem', left: '50%',
          transform: 'translateX(-50%)', zIndex: 10,
          display: 'flex', gap: '8px',
        }}>
          {filteredCarouselImages.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCarouselIndex(idx)}
              aria-label={`Go to slide ${idx + 1}`}
              style={{
                width: idx === carouselIndex ? '24px' : '8px',
                height: '8px',
                borderRadius: '4px',
                background: idx === carouselIndex ? '#fff' : 'rgba(255,255,255,0.5)',
                border: 'none', cursor: 'pointer', padding: 0,
                transition: 'all 0.3s ease',
              }}
            />
          ))}
        </div>
      </div>

      {/* About Section */}
      <section id="about" className="section section-search white-text center scrollspy" style={{backgroundColor: '#8C1515', padding: '1rem 0 2.5rem'}}>
        <div className="container" style={{maxWidth: '100%', width: '92%'}}>
          {/* Desktop card: flex with oval on left, text on right */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            borderRadius: '1rem',
            overflow: 'hidden',
            background: '#8C1515',
          }}>
            <div className="about-card-oval-col" style={{
              flexShrink: 0,
              flexGrow: 0,
              flexBasis: '42%',
              backgroundImage: 'url(/img/oval.jpeg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              margin: '0.25rem 1rem 1.5rem',
              borderRadius: '20px',
            }} />
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              padding: '0 1.75rem 1.25rem',
              textAlign: 'left',
            }}>
              <h2 className="about-section-title" style={{color: 'white', fontWeight: '700', fontSize: '1.05rem', marginBottom: '1rem', marginTop: '0', textAlign: 'left', whiteSpace: 'nowrap'}}>About The Stanford Alumni Alliance On Innovation for Global Impact</h2>
              <span style={{color: 'rgba(255,255,255,0.92)', fontSize: '0.85rem', lineHeight: '1.65'}}>
                The <span style={{fontWeight: 900}}>Stanford Alumni Alliance on Innovation for Global Impact</span>, co-anchored within the <a href="https://kingcenter.stanford.edu" target="_blank" rel="noopener noreferrer" style={{color: 'white', textDecoration: 'underline'}}><span style={{fontWeight: 900}}>King Center for Global Development</span></a> and the <a href="https://alumni.stanford.edu" target="_blank" rel="noopener noreferrer" style={{color: 'white', textDecoration: 'underline'}}><span style={{fontWeight: 900}}>Stanford Alumni Association</span></a>, is dedicated to advancing innovation for global good and officially launches on May 5th, 2026 at the Stanford King Center.
                <br /><br />
                The Alliance seeks to connect the Stanford student and alumni community with partners addressing real-world development challenges, while fostering collaboration with global impact institutions and philanthropic organizations. It serves as a platform to mobilize deeply purpose-driven engagement by creating space for meaningful dialogue around innovation, including the transformative potential of artificial intelligence, for global impact.
                <br /><br />
                We invite you to join us and receive updates via the link below.
              </span>
              <div style={{marginTop: '1.5rem'}}>
                <a href="https://groups.stanford.edu/topics/48991/feed" target="_blank" rel="noopener noreferrer" className="contact-me-button">
                  Join Now
                  <i className="material-icons right">arrow_forward</i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Affiliations Section */}
      <section id="affiliations" className="affiliations-section scrollspy">
        <div className="container">
          <h2 className="section-title" style={{color: '#424242'}}>Affiliations</h2>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '3rem', flexWrap: 'wrap', padding: '1rem 0'}}>
            <a href="https://kingcenter.stanford.edu" target="_blank" rel="noopener noreferrer" className="affiliation-logo" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem', textDecoration: 'none'}}>
              <img src="/img/stanford.jpeg" alt="Stanford King Center on Global Development" style={{height: '80px', width: 'auto'}} />
              <span style={{color: '#8C1515', fontWeight: '600', fontSize: '0.82rem', textAlign: 'center', maxWidth: '160px', lineHeight: '1.4'}}>King Center on Global Development</span>
            </a>
            <a href="https://alumni.stanford.edu" target="_blank" rel="noopener noreferrer" className="affiliation-logo" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem', textDecoration: 'none'}}>
              <img src="/img/stanford.jpeg" alt="Stanford Alumni Association" style={{height: '80px', width: 'auto'}} />
              <span style={{color: '#8C1515', fontWeight: '600', fontSize: '0.82rem', textAlign: 'center', maxWidth: '160px', lineHeight: '1.4'}}>Stanford Alumni Association</span>
            </a>
          </div>
        </div>
      </section>

      {/* Photo Gallery Section */}
      {/* Team Section */}
      <section id="team" className="speaking-video-section scrollspy" style={{backgroundColor: 'white'}}>
        <div className="container">
          <h2 className="speaking-video-title" style={{color: '#424242'}}>Team</h2>

          {/* Co-Presidents */}
          <p style={{textAlign: 'center', color: '#8C1515', fontWeight: '600', fontSize: '0.85rem', letterSpacing: '1px', textTransform: 'uppercase', marginTop: '1rem', marginBottom: '1rem'}}>Co-Founders & Co-Presidents</p>
          <div className="row">
            {coPresidents.map(member => (
              <div key={member.id} className="col s12 m6">
                <div className="video-card">
                  <div style={{height: '260px', backgroundColor: '#8C1515', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.75rem'}}>
                    {member.image ? (
                      <img src={member.image} alt={member.name} style={{width: '220px', height: '220px', borderRadius: '6px', objectFit: 'cover', display: 'block'}} />
                    ) : (
                      <div style={{width: '220px', height: '220px', borderRadius: '6px', backgroundColor: '#6e1111', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <i className="material-icons" style={{color: 'white', fontSize: '38px'}}>person</i>
                      </div>
                    )}
                  </div>
                  <div className="video-card-content" style={{padding: '0.75rem 1rem 1rem'}}>
                    <p style={{color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', margin: '0 0 0.4rem'}}>{member.title}</p>
                    <h3 className="video-title" style={{marginBottom: '1rem'}}>{member.name}</h3>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.75rem'}}>
                      {/* <a href={member.linkedin} target="_blank" rel="noopener noreferrer" style={{width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#000000', color: 'white', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none'}}>
                        <i className="fab fa-linkedin" style={{fontSize: '1.1rem'}}></i>
                      </a> */}
                      <button onClick={() => toggleTeam(member.id)} style={{backgroundColor: '#000000', border: 'none', borderRadius: '50%', cursor: 'pointer', color: 'white', width: '40px', height: '40px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: 0}}>
                        <i className="material-icons" style={{transition: 'transform 0.3s ease', transform: teamOpen[member.id] ? 'rotate(180deg)' : 'rotate(0deg)'}}>expand_more</i>
                      </button>
                    </div>
                    {teamOpen[member.id] && (
                      <div style={{marginTop: '1rem', backgroundColor: '#000000', borderRadius: '8px', padding: '1rem', color: 'rgba(255,255,255,0.85)', fontSize: '0.85rem', lineHeight: '1.6'}}>
                        {member.description.split('\n\n').map((paragraph, idx, arr) => (
                          <p
                            key={`${member.id}-paragraph-${idx}`}
                            style={{
                              margin: idx === arr.length - 1 ? 0 : '0 0 0.9rem 0',
                              textAlign: 'left'
                            }}
                          >
                            {paragraph}
                          </p>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Founding Team Members */}
          <p style={{textAlign: 'center', color: '#8C1515', fontWeight: '600', fontSize: '0.85rem', letterSpacing: '1px', textTransform: 'uppercase', marginTop: '1rem', marginBottom: '1rem'}}>Founding Team Members</p>

          {/* Rows 1–3: pairs */}
          {[foundingTeam.slice(0, 2), foundingTeam.slice(2, 4), foundingTeam.slice(4, 6), foundingTeam.slice(6, 8)].map((pair, rowIdx) => (
            <div className="row" key={`ft-row-${rowIdx}`}>
              {pair.map(member => (
                <div key={member.id} className="col s12 m6">
                  <div className="video-card">
                    <div style={{height: '260px', backgroundColor: '#8C1515', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.75rem'}}>
                      {member.image ? (
                        <img src={member.image} alt={member.name} style={{width: '220px', height: '220px', borderRadius: '6px', objectFit: 'cover', display: 'block'}} />
                      ) : (
                        <div style={{width: '220px', height: '220px', borderRadius: '6px', backgroundColor: '#6e1111', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          <i className="material-icons" style={{color: 'white', fontSize: '38px'}}>person</i>
                        </div>
                      )}
                    </div>
                    <div className="video-card-content" style={{padding: '0.75rem 1rem 1rem'}}>
                      <p style={{color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem', margin: '0 0 0.4rem', ...(member.id === 'ft1' ? {textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: '0.25rem'} : {})}} className={member.id === 'ft1' ? 'thay-title' : ''}>{member.title}</p>
                      <h3 className="video-title" style={{marginBottom: '1rem'}}>{member.name}</h3>
                      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.75rem'}}>
                        {member.description && (
                          <button onClick={() => toggleTeam(member.id)} style={{backgroundColor: '#000000', border: 'none', borderRadius: '50%', cursor: 'pointer', color: 'white', width: '40px', height: '40px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: 0}}>
                            <i className="material-icons" style={{transition: 'transform 0.3s ease', transform: teamOpen[member.id] ? 'rotate(180deg)' : 'rotate(0deg)'}}>expand_more</i>
                          </button>
                        )}
                      </div>
                      {teamOpen[member.id] && member.description && (
                        <div style={{marginTop: '1rem', backgroundColor: '#000000', borderRadius: '8px', padding: '1rem', color: 'rgba(255,255,255,0.85)', fontSize: '0.85rem', lineHeight: '1.6'}}>
                          {member.description.split('\n\n').map((paragraph, idx, arr) => (
                            <p key={`${member.id}-p-${idx}`} style={{margin: idx === arr.length - 1 ? 0 : '0 0 0.9rem 0', textAlign: 'left'}}>{paragraph}</p>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>

      {/* Events Section */}
      {/* SDGs Section */}
      <section id="sdgs" className="section scrollspy" style={{backgroundColor: '#f9f9f9', paddingTop: '1rem', paddingBottom: '2.5rem'}}>
        <div className="container">
          <h2 className="section-title" style={{color: '#424242', textAlign: 'center', fontSize: '1.55rem', marginBottom: '0.5rem'}}>Artificial Intelligence for the Sustainable Development Goals (SDG) Series</h2>
          <p style={{textAlign: 'center', color: '#666', fontSize: '0.9rem', maxWidth: '640px', margin: '0 auto 0.85rem'}}>
            The Alliance is committed to advancing all 17 UN Sustainable Development Goals through innovation, collaboration, and purposeful action.
          </p>
          <div className="sdg-grid">
            {[
              { n: 1,  color: '#E5243B', icon: 'volunteer_activism',      label: 'No Poverty' },
              { n: 2,  color: '#DDA63A', icon: 'grain',                   label: 'Zero Hunger' },
              { n: 3,  color: '#4C9F38', icon: 'favorite',                label: 'Good Health & Well-Being' },
              { n: 4,  color: '#C5192D', icon: 'school',                  label: 'Quality Education' },
              { n: 5,  color: '#FF3A21', icon: 'wc',                      label: 'Gender Equality' },
              { n: 6,  color: '#26BDE2', icon: 'opacity',                 label: 'Clean Water & Sanitation' },
              { n: 7,  color: '#FCC30B', icon: 'wb_sunny',                label: 'Affordable & Clean Energy' },
              { n: 8,  color: '#A21942', icon: 'trending_up',             label: 'Decent Work & Economic Growth' },
              { n: 9,  color: '#FD6925', icon: 'precision_manufacturing', label: 'Industry, Innovation & Infrastructure' },
              { n: 10, color: '#DD1367', icon: 'equalizer',               label: 'Reduced Inequalities' },
              { n: 11, color: '#FD9D24', icon: 'location_city',           label: 'Sustainable Cities & Communities' },
              { n: 12, color: '#BF8B2E', icon: 'recycling',               label: 'Responsible Consumption & Production' },
              { n: 13, color: '#3F7E44', icon: 'cloud',                   label: 'Climate Action' },
              { n: 14, color: '#0A97D9', icon: 'waves',                   label: 'Life Below Water' },
              { n: 15, color: '#56C02B', icon: 'park',                    label: 'Life on Land' },
              { n: 16, color: '#00689D', icon: 'gavel',                   label: 'Peace, Justice & Strong Institutions' },
              { n: 17, color: '#19486A', icon: 'groups',                  label: 'Partnerships for the Goals' },
            ].map(({ n, color, icon, label }) => (
              <a
                key={n}
                href={`https://sdgs.un.org/goals/goal${n}`}
                target="_blank"
                rel="noopener noreferrer"
                className="sdg-tile"
                style={{
                  backgroundColor: color,
                  borderRadius: '6px',
                  padding: '0.4rem 0.25rem',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textDecoration: 'none',
                  color: 'white',
                  textAlign: 'center',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.12)'; }}
              >
                <span style={{fontSize: '0.5rem', fontWeight: '700', letterSpacing: '1px', opacity: 0.9, marginBottom: '0.1rem'}}>SDG {n}</span>
                <i className="material-icons" style={{fontSize: '1.05rem', marginBottom: '0.1rem'}}>{icon}</i>
                <span style={{fontSize: '0.5rem', fontWeight: '600', lineHeight: '1.2'}}>{label}</span>
              </a>
            ))}
          </div>

          {/* Event videos */}
          <div style={{marginTop: '1.75rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2rem'}}>
            <div className="event-video-wrap">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo" style={{backgroundColor: '#8C1515'}}>Stanford</div>
                </div>
                <EventYouTube
                  videoId="SM9M4ZR3pcY"
                  title="Reimagining How AI Can Transform Our World: From Innovation To Action"
                  thumb="https://img.youtube.com/vi/SM9M4ZR3pcY/hqdefault.jpg"
                />
                <div className="video-card-content">
                  <h3 className="video-title">Reimagining How AI Can Transform Our World: From Innovation To Action</h3>
                  <a href="https://www.youtube.com/watch?v=SM9M4ZR3pcY" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Watch on</span>
                    <i className="fab fa-youtube"></i>
                    <span>YouTube</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="event-video-wrap">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo" style={{backgroundColor: '#8C1515'}}>Stanford</div>
                </div>
                <EventYouTube
                  videoId="Uwtwow_VJ50"
                  title="Inaugural Event — Reimagining AI to Accelerate Sustainable Futures: From Ideas to Action"
                  thumb="https://img.youtube.com/vi/Uwtwow_VJ50/maxresdefault.jpg"
                />
                <div className="video-card-content">
                  <h3 className="video-title">Inaugural Event — Reimagining AI to Accelerate Sustainable Futures: From Ideas to Action</h3>
                  <a href="https://www.youtube.com/watch?v=Uwtwow_VJ50" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Watch on</span>
                    <i className="fab fa-youtube"></i>
                    <span>YouTube</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AI for SDG Councils Section */}
      <section id="councils" className="section scrollspy" style={{backgroundColor: '#f9f9f9', paddingTop: '3rem', paddingBottom: '3rem'}}>
        <div className="container">
          <h2 className="section-title" style={{color: '#424242', textAlign: 'center'}}>AI for SDG Councils</h2>
          <p style={{color: '#424242', fontSize: '0.85rem', fontWeight: '500', textAlign: 'center', marginTop: '1rem'}}>Coming Soon!</p>
        </div>
      </section>

      {/* Music Section */}
      {false && (
      <section id="music" className="speaking-video-section scrollspy">
        <div className="container">
          <h2 className="speaking-video-title">Music</h2>
          
          <div className="row" style={{marginTop: '3rem'}}>
            {/* Aurora Hunters Song Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo ted-logo" style={{backgroundColor: '#c4122e'}}>iHeart</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/arealdiva.png" alt="Aurora Hunters" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">play_circle_filled</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">Aurora Hunters</h3>
                  <a href="https://www.iheart.com/artist/arealdiva-46550165/" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Listen on</span>
                    <i className="fas fa-music"></i>
                    <span>iHeart Radio</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Radio One International Video Card */}
            <div className="col s12 m6">
              <div className="video-card">
                <div className="video-card-header">
                  <div className="video-actions">
                    <button className="video-action-btn">
                      <i className="material-icons">access_time</i>
                    </button>
                    <button className="video-action-btn">
                      <i className="material-icons">share</i>
                    </button>
                  </div>
                  <div className="video-brand-logo ted-logo" style={{backgroundColor: '#ff0000'}}>Radio One International</div>
                </div>
                <div className="video-thumbnail-container">
                  <img src="/img/radiooneinternational.png" alt="Radio One International" className="video-thumbnail" />
                  <div className="play-button">
                    <i className="material-icons">play_circle_filled</i>
                  </div>
                </div>
                <div className="video-card-content">
                  <h3 className="video-title">Radio One International</h3>
                  <a href="https://www.youtube.com/watch?v=8P6fCG8q5m4&t=425s" target="_blank" rel="noopener noreferrer" className="youtube-watch-btn">
                    <span>Watch on</span>
                    <i className="fab fa-youtube"></i>
                    <span>YouTube</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      )}

      {/* Updates/Social Media Section */}
      <section id="updates" className="section section-follow black darken-2 white-text center" style={{display: 'none'}}>
        <div className="container">
          <div className="row">
            <div className="col s12">
              <h2 className="section-title" style={{color: 'white'}}>Follow Me</h2>
              <p>Follow me on Social Media</p>
              <a href="https://www.instagram.com/arealdiva/" target="_blank" rel="noopener noreferrer" className="white-text">
                <i className="fab fa-instagram fa-4x"></i>
              </a>
              <a href="https://x.com/adivawhocodes/" target="_blank" rel="noopener noreferrer" className="white-text">
                <span style={{fontWeight: 'bold', fontSize: '4rem'}}>X</span>
              </a>
              <a href="https://www.linkedin.com/in/diva-sharma/" target="_blank" rel="noopener noreferrer" className="white-text">
                <i className="fab fa-linkedin fa-4x"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      {false && (
      <section className="section section-icons center" id="projects" style={{backgroundColor: '#3d0000', paddingTop: '4rem', paddingBottom: '4rem'}}>
        <div className="container">
          <h2 className="section-title" style={{color: 'white'}}>Projects</h2>
          <div className="projects-carousel-container">
            <button className="projects-arrow projects-arrow-left" onClick={prevProjects}>
              <i className="material-icons">chevron_left</i>
            </button>
            <div className="projects-carousel">
              <div className="projects-track" style={{transform: `translateX(-${projectsIndex * 33.333}%)`}}>
                {projects.map((project, index) => (
                  <div key={index} className="project-card">
                  <div className="card-panel project-card-panel">
                    <i className={`material-icons large white-text`}>{project.icon}</i>
                    <h4>{project.title}</h4>
                    <p style={{textAlign: 'left', color: 'white'}}>{project.description}</p>
                  </div>
                  </div>
                ))}
              </div>
            </div>
            <button className="projects-arrow projects-arrow-right" onClick={nextProjects}>
              <i className="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </section>
      )}
    
      {/* Blogs & Writing */}
      <section id="blogs" className="scrollspy" style={{backgroundColor: '#8C1515', padding: '2.5rem 0'}}>
        <div className="container" style={{maxWidth: '100%', width: '92%'}}>
          <h2 className="section-title" style={{color: 'white', textAlign: 'center', marginBottom: '1.5rem', marginTop: '0', paddingTop: '0.5rem'}}>Blogs &amp; Writing</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: '42% 1fr',
            gridTemplateRows: '340px',
            maxWidth: '600px',
            margin: '0 auto',
            borderRadius: '1rem',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.28)',
            background: '#8C1515',
            border: 'none',
            outline: 'none',
          }}>
            <div style={{
              backgroundImage: 'url(/img/quad.jpeg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
            }} />
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '2rem 2.25rem', textAlign: 'center'}}>
              <h3 style={{color: 'white', fontSize: '1.3rem', fontWeight: '700', margin: '0 0 0.75rem'}}>Coming Soon!</h3>
              <p style={{color: 'rgba(255,255,255,0.88)', fontSize: '0.85rem', lineHeight: '1.85', margin: 0}}>Articles and blog posts will be featured here.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section — commented out, may re-add later
      <section id="contact" className="section section-contact scrollspy" style={{backgroundColor: 'white', paddingTop: '1.25rem', paddingBottom: '1.5rem', marginTop: '0'}}>
        <div className="container">
          <div className="contact-layout-row">
            <div className="contact-left-col">
              <div className="contact-quad-card">
                <img src="/img/quad.jpeg" alt="Stanford Quad" className="contact-quad-img" />
              </div>
              <div className="contact-socials" style={{textAlign: 'center', marginTop: '1.25rem'}}>
                <a href="https://www.linkedin.com/posts/stanfordkingctr_sdg-aiforgood-ai-activity-7402200795414487040-c0T1?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAABp-tjEBDokRwzKqfLf7eX_le4HBw12mAlc" target="_blank" rel="noopener noreferrer" className="contact-social-icon">
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://groups.stanford.edu/topics/48991/feed" target="_blank" rel="noopener noreferrer" className="contact-social-icon" style={{overflow: 'hidden', padding: 0}}>
                  <img src="/img/stanford.jpeg" alt="Stanford Groups" style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}} />
                </a>
              </div>
            </div>
            <div className="contact-right-col">
              <div className="contact-form-container">
                <h2 className="contact-form-title">Contact The Alliance</h2>
                {formSubmitted ? (
                  <div style={{textAlign: 'center', padding: '2.5rem 1rem'}}>
                    <i className="material-icons" style={{fontSize: '3rem', color: '#8C1515', display: 'block', marginBottom: '1rem'}}>check_circle</i>
                    <p style={{fontSize: '1.1rem', fontWeight: '600', color: '#424242', marginBottom: '0.5rem'}}>Your request has been received!</p>
                    <p style={{fontSize: '0.9rem', color: '#757575'}}>Thank you for reaching out. We will be in contact with you shortly.</p>
                  </div>
                ) : (
                <form className="contact-form" onSubmit={handleContactSubmit}>
                  <div className="contact-input-field" style={{marginBottom: '1rem'}}>
                    <label htmlFor="fullName" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Name <span style={{color: '#8C1515'}}>*</span>
                    </label>
                    <input type="text" id="fullName" className="contact-input" required placeholder="Enter your full name" />
                  </div>
                  <div className="contact-input-field" style={{marginBottom: '1rem'}}>
                    <label htmlFor="email" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Email <span style={{color: '#8C1515'}}>*</span>
                    </label>
                    <input type="email" id="email" className="contact-input" required />
                  </div>
                  <div className="contact-input-field" style={{marginBottom: '1rem'}}>
                    <label htmlFor="subject" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Subject <span style={{color: '#8C1515'}}>*</span>
                    </label>
                    <input type="text" id="subject" className="contact-input" required placeholder="Enter subject" />
                  </div>
                  <div className="contact-input-field" style={{marginBottom: '1.5rem'}}>
                    <label htmlFor="message" style={{display: 'block', marginBottom: '0.4rem', fontSize: '0.85rem', color: '#424242', fontWeight: '500'}}>
                      Message <span style={{color: '#8C1515'}}>*</span>
                    </label>
                    <textarea id="message" className="contact-input contact-textarea" rows="4" required></textarea>
                  </div>
                  <button type="submit" className="contact-submit-btn">SUBMIT</button>
                </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      */}
    
      {/* Footer */}
      <footer className="footer-section black darken-2 white-text center">
        <div className="container">
          <img src="/img/Global Impact group logo W.jpg" alt="Stanford Alumni Alliance" style={{height: '140px', width: 'auto', borderRadius: '8px', marginBottom: '1.5rem'}} />
          <p className="footer-note" style={{fontSize: '1.1rem', marginBottom: '2rem'}}>
            Stay Connected
          </p>
          <div className="footer-socials">
            <a href="https://www.linkedin.com/posts/stanfordkingctr_sdg-aiforgood-ai-activity-7402200795414487040-c0T1?utm_source=social_share_send&utm_medium=member_desktop_web&rcm=ACoAABp-tjEBDokRwzKqfLf7eX_le4HBw12mAlc" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://groups.stanford.edu/topics/48991/feed" target="_blank" rel="noopener noreferrer" className="footer-social-icon" style={{overflow: 'hidden', padding: 0}}>
              <img src="/img/stanford.jpeg" alt="Stanford Groups" style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%'}} />
            </a>
          </div>
          <p className="footer-copyright" style={{marginTop: '2rem', fontSize: '0.9rem', opacity: 0.7}}>
            Made in Stanford, CA
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;





